import React, { FC } from 'react';

import { MethodOfReceptionItem } from 'bus/methodOfReception/types';

type Props = {
  methodOfReception: MethodOfReceptionItem;
};

export const MasterDetailView: FC<Props> = ({ methodOfReception }) => {
  return (
    <div>
      <div className="d-flex">
        <div className="d-flex column mr-10">
          <div className="info sp-btw">
            <div className="info__title">Метод приёма</div>
            <div className="info__child">{methodOfReception?.typeDescription}</div>
          </div>
          {methodOfReception.type === 1 && (
            <div className="info sp-btw">
              <div className="info__title">Доплата за рюмку</div>
              <div className="info__child">{methodOfReception?.glassConcretePrice}</div>
            </div>
          )}
          {methodOfReception.type === 3 && (
            <>
              <div className="info sp-btw">
                <div className="info__title">Транспорт</div>
                <div className="info__child">{methodOfReception?.transport}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Водитель</div>
                <div className="info__child">{methodOfReception?.driver}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Телефон</div>
                <div className="info__child">{methodOfReception?.pumpPhone}</div>
              </div>
            </>
          )}
          <div className="info sp-btw">
            <div className="info__title">Комментарий</div>
            <div className="info__child">{methodOfReception?.comment}</div>
          </div>
          {methodOfReception.type === 3 && (
            <>
              <div className="info sp-btw">
                <div className="info__title">Кол-во кубов</div>
                <div className="info__child">{methodOfReception?.pumpQuantity}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Цена за куб</div>
                <div className="info__child">{methodOfReception?.pumpPrice}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Минимальная цена</div>
                <div className="info__child">{methodOfReception?.pumpPriceMinimal}</div>
              </div>
            </>
          )}
        </div>
        <div className="d-flex column mr-10">
          {methodOfReception.type === 3 && (
            <>
              <div className="info sp-btw">
                <div className="info__title">Подача</div>
                <div className="info__child">{methodOfReception?.pumpInnings}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Гаситель</div>
                <div className="info__child">{methodOfReception?.pumpQuencher}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Переезд</div>
                <div className="info__child">{methodOfReception?.pumpMoving}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Трубы</div>
                <div className="info__child">{methodOfReception?.pumpPipes}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Простой</div>
                <div className="info__child">{methodOfReception?.downtime}</div>
              </div>
              <div className="info sp-btw">
                <div className="info__title">Итого</div>
                <div className="info__child">{methodOfReception?.pumpTotal}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
